var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('link',{attrs:{"rel":"stylesheet","href":"https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"}}),_c('router-view'),_c('div',{staticStyle:{"padding-top":"2em"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }